import React, { useEffect, useState } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsFinalDecorScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const [selectedDecor1, setSelectedDecor1] = useState("None");
    const [selectedDecor2, setSelectedDecor2] = useState("None");
    const [selectedFont, setSelectedFont] = useState("Courier New");

    const layer1Decors = [
        { value: "None", label: "Нет" },
        { value: props.TextString2, label: props.TextString2 },
        { value: props.TextString3, label: props.TextString3 },
        { value: props.TextString4, label: props.TextString4 },
    ].filter((decor) => decor.value !== undefined && decor.value !== "None" || decor.value === "None");

    const layer2Decors = [
        { value: "None", label: "Нет" },
        { value: props.TextString5, label: props.TextString5 },
        { value: props.TextString6, label: props.TextString6 },
        { value: props.TextString7, label: props.TextString7 },
    ].filter((decor) => decor.value !== undefined && decor.value !== "None" || decor.value === "None");

    const fonts = ["Courier New", "Arial", "Times New Roman", "Comic Sans"];

    const blockStyle = {
        width: "90%",
        margin: "0 auto 15px auto",
        padding: "10px",
        border: "1px solid #999",
        borderRadius: "8px",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        color: "black",
    };

    const decorListStyle = {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        overflowX: "auto",
        paddingBottom: "8px",
    };

    const decorOptionStyle = {
        minWidth: "90px",
        maxWidth: "110px",
        padding: "8px",
        border: "1px solid #aaa",
        borderRadius: "8px",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        textAlign: "center",
    };

    const decorImageStyle = {
        width: "75px",
        height: "112px",
        objectFit: "contain",
        display: "block",
        margin: "5px auto 0 auto",
    };

    const renderDecorBlock = (decors, selectedDecor, setSelectedDecor, radioName) => (
        <div style={blockStyle}>
            <div style={decorListStyle}>
                {decors.map((decor) => (
                    <label key={radioName + decor.value} style={decorOptionStyle}>
                        <input
                            type="radio"
                            name={radioName}
                            checked={selectedDecor === decor.value}
                            onChange={() => setSelectedDecor(decor.value)}
                        />
                        <div style={{ marginTop: "5px" }}>
                            {decor.label}
                        </div>

                        {decor.value !== "None" && (
                            <img
                                src={"https://cyberbox.trgu.ru/public/cardsgame/decors/" + decor.value + ".png"}
                                alt={decor.label}
                                style={decorImageStyle}
                            />
                        )}
                    </label>
                ))}
            </div>
        </div>
    );

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><b>В открытке есть вот это:</b></div>
            <div className="divtext_slov">{props.TextString}</div>
            <br />

            <div className="divtext_slov"><b>Выберите декор на слой 1:</b></div>
            <br />
            {renderDecorBlock(layer1Decors, selectedDecor1, setSelectedDecor1, "decorLayer1")}

            <div className="divtext_slov"><b>Выберите декор на слой 2:</b></div>
            <br />
            {renderDecorBlock(layer2Decors, selectedDecor2, setSelectedDecor2, "decorLayer2")}

            <div className="divtext_slov"><b>Выберите почерк:</b></div>
            <br />

            <div style={blockStyle}>
                {fonts.map((font) => (
                    <label key={font} style={{ display: "block", marginBottom: "10px", fontFamily: font === "Comic Sans" ? "Comic Sans MS, Comic Sans, cursive" : font }}>
                        <input
                            type="radio"
                            name="font"
                            checked={selectedFont === font}
                            onChange={() => setSelectedFont(font)}
                        />
                        {" "}
                        {font}
                    </label>
                ))}
            </div>

            <button
                type="button"
                onClick={() => {
                    props.sendMessage(`sendtoserver|slov\\addtext\\${selectedDecor1}+${selectedDecor2}+${selectedFont}`);
                }}
            >
                Отправить
            </button>
        </div>
    );
};